import map from 'lodash/fp/map'
import pipe from 'lodash/fp/pipe'
import zipObject from 'lodash/fp/zipObject'
import * as Redux from 'redux'
import * as Utils from './utils'

export interface DetailPanelAction<Value> extends Redux.Action {
  value: Value
}

export const createActions = pipe(
  Utils.createConstants,
  map((type) => <Value>(value: Value) => ({type, value})),
)

export const createActionsMap = pipe(
  createActions,
  zipObject(Utils.verbs),
)



// WEBPACK FOOTER //
// ./src/components/detail-panel/actions.ts